// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import React from 'react';
import styled from '@emotion/styled';
import { base, flat, translucent } from '@kintent/glide';

import { Flex } from './Flex';
import { BREAKPOINTS } from '../lib/constants';

const CardContainer = styled(Flex)`
  padding: 16px;

  background-color: ${({ theme }) => theme.palette.white};

  box-shadow: ${base.boxShadow.drop} ${({ theme }) => translucent(theme.color.shadow.drop, '20%')};
  border: 1px solid ${({ theme }) => flat(theme.color.system.gray, '20%')};

  border-radius: 8px;

  @media (min-width: ${BREAKPOINTS.TABLET}px) {
    padding: 32px;
  }
`;

export default CardContainer;
